module.exports = __webpack_public_path__ + "img/index_img6.10eff07f.png";